export const INIT_SETTING = 'INIT_SETTING';
export function initSetting(data) {
    return {type: INIT_SETTING, data};
}
